import { Codification } from './Codification';
import { IOptionItem } from './IOptionItem';
export class Lock implements IOptionItem {
    public static MIN_TRIES: number = 3;
    public static MAX_TRIES: number = 10;

    constructor(
        public id?: number,
        public digits?: number,
        public tries: number = Lock.MAX_TRIES,
        public durability?: number,
        public name?: string,
        public description?: string,
        public image: string = "assets/images/lock.png",
        public codification: Codification = new Codification("numbers", null, 10)
    ) {

    }
    public static fromData(data: any) {
        if (!data) return;
        let o = new Lock(
            data.id,
            data.digits,
            data.tries,
            data.durability,
            data.name,
            data.description,
            data.image,
            Codification.fromData(data.codification),

        )
        return o;
    }
    public get value() {
        return this.digits + "";
    }
    public get icon() { return "fa-asterisk" }
}